'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$() {
  this.c5U = null;
  this.c5V = false;
  this.c5S = null;
  this.c5T = false;
  this.c5W = null;
  this.c5X = false;
  this.c5Y = null;
  this.c5Z = false;
}
export { $c_Lpresto_types$DirectiveSelector$ as $c_Lpresto_types$DirectiveSelector$ };
$p = $c_Lpresto_types$DirectiveSelector$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$() {
}
export { $h_Lpresto_types$DirectiveSelector$ as $h_Lpresto_types$DirectiveSelector$ };
$h_Lpresto_types$DirectiveSelector$.prototype = $p;
$p.cI7 = (function() {
  if ((!this.c5V)) {
    this.c5U = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5V = true;
  }
  return this.c5U;
});
$p.v6 = (function() {
  if ((!this.c5T)) {
    this.c5S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5T = true;
  }
  return this.c5S;
});
$p.cIQ = (function() {
  if ((!this.c5X)) {
    this.c5W = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5X = true;
  }
  return this.c5W;
});
$p.cJ6 = (function() {
  if ((!this.c5Z)) {
    this.c5Y = new $c_Lpresto_types$DirectiveSelector$$anon$66(this);
    this.c5Z = true;
  }
  return this.c5Y;
});
$p.a32 = (function(str) {
  try {
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(document.querySelector(str));
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
  return $x_1.sH();
});
var $d_Lpresto_types$DirectiveSelector$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$, "presto.types$DirectiveSelector$", ({
  ZF: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveSelector$ as $d_Lpresto_types$DirectiveSelector$ };
var $n_Lpresto_types$DirectiveSelector$;
function $m_Lpresto_types$DirectiveSelector$() {
  if ((!$n_Lpresto_types$DirectiveSelector$)) {
    $n_Lpresto_types$DirectiveSelector$ = new $c_Lpresto_types$DirectiveSelector$();
  }
  return $n_Lpresto_types$DirectiveSelector$;
}
export { $m_Lpresto_types$DirectiveSelector$ as $m_Lpresto_types$DirectiveSelector$ };
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$$anon$66(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveSelector$$anon$66 as $c_Lpresto_types$DirectiveSelector$$anon$66 };
$p = $c_Lpresto_types$DirectiveSelector$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$$anon$66;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$$anon$66() {
}
export { $h_Lpresto_types$DirectiveSelector$$anon$66 as $h_Lpresto_types$DirectiveSelector$$anon$66 };
$h_Lpresto_types$DirectiveSelector$$anon$66.prototype = $p;
$p.bn = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return ($m_Lpresto_types$DirectiveSelector$().a32(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "CSS Selector is not valid")));
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$DirectiveSelector$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$$anon$66, "presto.types$DirectiveSelector$$anon$66", ({
  ZG: 1,
  K: 1
}));
export { $d_Lpresto_types$DirectiveSelector$$anon$66 as $d_Lpresto_types$DirectiveSelector$$anon$66 };
//# sourceMappingURL=presto.types$-Directive-Selector$.js.map
